/**
 * Shared theme variants for the Home page.
 *
 * Design principle: each section should have a distinct tonal "weight"
 * so the page reads as a layered composition rather than flat blocks.
 *
 *   Hero      →  constellation + texture   (visual anchor)
 *   Services  →  slightly tinted surface    (stone-200 / zinc-900)
 *   About     →  back to page background   (--background)
 *   Contact   →  bold gradient band         (orange→rose / blue→indigo)
 */

export const homeTheme = {
  // ─── Services Section ───────────────────────────────────────────────────────
  servicesSection:
    "relative z-30 w-full pt-20 pb-24 sm:pt-24 sm:pb-32 bg-stone-100 dark:bg-zinc-900",

  serviceCard:
    "relative flex flex-col group p-8 rounded-3xl bg-gradient-to-tr from-white to-orange-50 dark:from-zinc-800/60 dark:to-zinc-800/60 border border-stone-200/60 dark:border-zinc-700/50 shadow-md hover:shadow-xl transition-all hover:-translate-y-1 overflow-hidden backdrop-blur-sm",

  serviceIconContainer:
    "flex h-12 w-12 items-center justify-center rounded-xl bg-orange-100 dark:bg-orange-950/40 text-orange-600 dark:text-orange-500 group-hover:scale-110 transition-transform",

  // ─── About Section ──────────────────────────────────────────────────────────
  aboutSection:
    "relative z-30 w-full py-12 sm:py-20 bg-transparent",

  // ─── Contact Section ────────────────────────────────────────────────────────
  contactSection:
    "relative z-30 w-full py-12 sm:py-16 text-white selection:bg-white/30 transition-colors duration-500 bg-linear-to-br from-orange-500 via-orange-600 to-rose-600 dark:from-blue-700 dark:via-blue-600 dark:to-indigo-600",
  contactDesc:
    "mx-auto mt-6 max-w-xl text-lg leading-8 transition-colors text-orange-50 dark:text-blue-100",
  contactButtonMail:
    "rounded-full bg-white px-8 py-4 text-sm font-semibold shadow-sm transition-all shadow-[0_0_20px_rgba(255,255,255,0.25)] text-orange-600 hover:bg-orange-50 dark:text-blue-600 dark:hover:bg-blue-50",
  contactButtonPhone:
    "text-sm font-semibold leading-6 text-white transition-colors hover:text-orange-100 dark:hover:text-blue-100",
};
